import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import { useSelector } from 'react-redux';
/**
 * This hook is used to filter and return for easy usage the labels that are used everywhere in the project.
 * ----
 * @why As it is build right now, that context is still not functional, and still as HOCs most of the data
 * so the data is not accessible from hooks, in a future, if labels/language is migrated to context
 * this hook could end up being just 1 parameter, entitiesIds, as the two others would be retrieved directly
 * from context.
 * ----
 * @param {string|array} entitiesIds Contains the entitiesId of the labels that are needed.
 * @param {string|null} language Labels of the language specified will be retrieved
 * @param {object[]|null} arrayOfLabelsFromRedux Array of objects that contains all the labels.
 * ----
 * @throw Error if arrayOfLabels is not empty and don't have the expected format.
 * ----
 * @returns {object}
 */

var useLabelsFromRedux = function useLabelsFromRedux(entitiesIds, language, arrayOfLabelsFromRedux) {
  var labelsFromReduxSelector = useSelector(function (state) {
    return state.shared.labels;
  });
  var finalLabelsUsed = arrayOfLabelsFromRedux || labelsFromReduxSelector;
  var labelsAsObjects;

  if (finalLabelsUsed && !_Array$isArray(finalLabelsUsed) && typeof finalLabelsUsed === 'object' && finalLabelsUsed.Label) {
    labelsAsObjects = finalLabelsUsed.Label;
  } else if (finalLabelsUsed && _Array$isArray(finalLabelsUsed)) {
    // Compatibility with the old format (array)
    labelsAsObjects = {};
    finalLabelsUsed.forEach(function (translation) {
      labelsAsObjects[translation.key.entityId] = labelsAsObjects[translation.key.entityId] || {};
      labelsAsObjects[translation.key.entityId][translation.key.fieldName] = translation.value;
    });
  } else {
    throw Error('The labels are not valid. Expecting an object with a "Label" key inside or an Array of translations.');
  }

  return _objectSpread({}, labelsAsObjects, {
    /**
     * Can also be used to access labels and implements a fallback in case the label is not set or does not exist
     * @param {string} entityId
     * @param {string} fieldName
     * @returns {*|string}
     */
    t: function t(entityId, fieldName) {
      return labelsAsObjects[entityId] && labelsAsObjects[entityId][fieldName] ? labelsAsObjects[entityId][fieldName] : "##".concat(entityId, ".").concat(fieldName, "##");
    }
  });
};

export default useLabelsFromRedux;